<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->
<template>
  <div class="salary-slip-holder">
    <div ref="contentToConvert" class="salary-slip-container">
      <header class="clearfix">
        <div id="company">
          <h2 id="heading">
            <strong>PAYSLIP</strong> {{ salaryDetails.month }}
            {{ salaryDetails.year }}
          </h2>
          <h2 class="name">{{ organization.name }}</h2>
          <div>
            {{ organization.street1 }}<br />
            {{ organization.street2 }}<br />
            {{ organization.city }}, {{ organization.state }} -
            {{ organization.zip }}
          </div>
        </div>
        <div id="logo">
          <img :src="organization.logo" />
        </div>
      </header>
      <main>
        <div class="employee-details">
          <div class="name-container">
            <h6 class="text-uppercase">{{ salaryDetails.empFullName }}</h6>
          </div>
          <div class="div-4-column">
            <div class="div-column">
              <div class="box-label">Date of Joining</div>
              <div class="box-value">{{ salaryDetails.joiningDate }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Designation</div>
              <div class="box-value">{{ salaryDetails.designation }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Pan No.</div>
              <div class="box-value">{{ salaryDetails.panNumber }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Monthly Salary</div>
              <div class="box-value">{{ salaryDetails.monthlySalary }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Payment Mode</div>
              <div class="box-value">{{ salaryDetails.paymentMode }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Bank</div>
              <div class="box-value">{{ salaryDetails.bank }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Bank IFSC</div>
              <div class="box-value">{{ salaryDetails.bankIfsc }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Account No.</div>
              <div class="box-value">{{ salaryDetails.accountNumber }}</div>
            </div>
          </div>
        </div>
        <div class="salary-details">
          <div class="name-container">
            <h6 class="text-uppercase">SALARY DETAILS</h6>
          </div>
          <div class="div-4-column border-bottom">
            <div class="div-column">
              <div class="box-label">Total Days</div>
              <div class="box-value">{{ salaryDetails.totalDays }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Total Leaves</div>
              <div class="box-value">{{ salaryDetails.totalLeaves }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Leave Adjusted</div>
              <div class="box-value">{{ salaryDetails.leaveAdjusted }}</div>
            </div>
            <div class="div-column">
              <div class="box-label">Total Payables Days</div>
              <div class="box-value">{{ salaryDetails.totalPayablesDays }}</div>
            </div>
          </div>
          <div class="div-2-column border-bottom mb5">
            <div class="div-column border-right">
              <div class="div-2-column-70-30">
                <div class="div-column text-bold">EARNINGS</div>
                <div class="div-column text-bold text-right pr10">Amount</div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column">Basic</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.basicSalary }}
                </div>
              </div>
              <div v-if="salaryDetails.hra" class="div-2-column-70-30">
                <div class="div-column">HRA</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.hra }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column">Conveyance Allowance</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.conveyanceAllowance }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column">Communication Allowance</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.communicationAllowance }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column">Special Allowance</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.specialAllowance }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column text-bold">Gross Earnings (A)</div>
                <div class="div-column text-right pr10">
                  {{ salaryDetails.totalEarnings }}
                </div>
              </div>
            </div>
            <div class="div-column">
              <div class="div-2-column-70-30">
                <div class="div-column text-bold pl10">CONTRIBUTIONS</div>
                <div class="div-column text-bold text-right">Amount</div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column pl10">Provident Fund</div>
                <div class="div-column text-right">
                  {{ salaryDetails.providentFund }}
                </div>
              </div>
              <div class="div-2-column-70-30 mb5">
                <div class="div-column text-bold pl10">
                  Total Contributions (B)
                </div>
                <div class="div-column text-right">
                  {{ salaryDetails.providentFund }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column text-bold pl10">TAXES & DEDUCTIONS</div>
                <div class="div-column text-bold text-right">Amount</div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column pl10">Professional Tax</div>
                <div class="div-column text-right">
                  {{ salaryDetails.professionalTax }}
                </div>
              </div>
              <div v-if="salaryDetails.tds" class="div-2-column-70-30">
                <div class="div-column pl10">TDS</div>
                <div class="div-column text-right">
                  {{ salaryDetails.tds }}
                </div>
              </div>
              <div class="div-2-column-70-30">
                <div class="div-column text-bold pl10">
                  Total Deductions (C)
                </div>
                <div class="div-column text-right">
                  {{ salaryDetails.totalDeductions }}
                </div>
              </div>
            </div>
          </div>
          <div class="div-2-column-40-60 mb20">
            <div>Net Earnings ( A - B - C )</div>
            <div class="text-bold">
              {{ salaryDetails.netPay }}
            </div>
          </div>
          <div class="note">
            <p>
              <strong class="text-bold">**Note :</strong> All amounts displayed
              in this payslip are in {{ salaryDetails.currency }}
            </p>
          </div>
        </div>
      </main>
      <footer>
        *This is computer generated statement, does not require signature.
      </footer>
    </div>
  </div>
  <div class="buttons-container">
    <oxd-form-actions>
      <oxd-button
        type="button"
        display-type="ghost"
        label="Close"
        @click="onCancel"
      />
      <oxd-button
        type="button"
        display-type="ghost"
        label="Download"
        @click="exportToPDF"
      />
    </oxd-form-actions>
  </div>
</template>
<script>
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export default {
  props: {
    salaryDetails: {
      type: Object,
      default: () => ({}),
    },
    organization: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  methods: {
    exportToPDF() {
      // Get the HTML content to convert
      const contentToConvert = this.$refs.contentToConvert;

      // Create a new jsPDF instance
      const pdf = new jsPDF('p', 'pt', 'a4');
      // Convert HTML to PDF
      pdf.html(contentToConvert, {
        callback: () => {
          // Save or download the PDF
          pdf.save(
            this.salaryDetails.month + '-' + this.salaryDetails.year + '.pdf',
          );
        },
        x: 30,
        y: 30,
        html2canvas: {
          scale: 0.8, // optional, improves performance for large content
        },
      });
    },
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>
<style src="./salary-slip.scss" lang="scss" scoped></style>
